export const countryCodeList = [
  { id: 1, code: "+91" }/*,
  { id: 2, code: "+7" },
  { id: 3, code: "+20" },
  { id: 4, code: "+27" },
  { id: 5, code: "+30" },
  { id: 6, code: "+31" },
  { id: 7, code: "+32" },
  { id: 8, code: "+33" },
  { id: 9, code: "+34" },
  { id: 10, code: "+36" },
  { id: 11, code: "+39" },
  { id: 12, code: "+40" },
  { id: 13, code: "+41" },
  { id: 14, code: "+43" },
  { id: 15, code: "+44" },
  { id: 16, code: "+45" },
  { id: 17, code: "+46" },
  { id: 18, code: "+48" },
  { id: 19, code: "+49" },
  { id: 20, code: "+51" },
  { id: 21, code: "+52" },
  { id: 22, code: "+54" },
  { id: 23, code: "+55" },
  { id: 24, code: "+56" },
  { id: 25, code: "+57" },
  { id: 26, code: "+58" },
  { id: 27, code: "+60" },
  { id: 28, code: "+61" },
  { id: 29, code: "+62" },
  { id: 30, code: "+63" },
  { id: 31, code: "+64" },
  { id: 32, code: "+65" },
  { id: 33, code: "+66" },
  { id: 34, code: "+81" },
  { id: 35, code: "+82" },
  { id: 36, code: "+84" },
  { id: 37, code: "+86" },
  { id: 38, code: "+90" },
  { id: 39, code: "+1" },
  { id: 40, code: "+92" },
  { id: 41, code: "+93" },
  { id: 42, code: "+94" },
  { id: 43, code: "+95" },
  { id: 44, code: "+98" },
  { id: 45, code: "+143" },
  { id: 46, code: "+212" },
  { id: 47, code: "+216" },
  { id: 48, code: "+225" },
  { id: 49, code: "+234" },
  { id: 50, code: "+254" },
  { id: 51, code: "+420" },
  { id: 52, code: "+591" },
  { id: 53, code: "+673" },
  { id: 54, code: "+678" },
  { id: 55, code: "+679" },
  { id: 56, code: "+682" },
  { id: 57, code: "+683" },
  { id: 58, code: "+685" },
  { id: 59, code: "+687" },
  { id: 60, code: "+688" },
  { id: 61, code: "+689" },
  { id: 62, code: "+691" },
  { id: 63, code: "+692" },
  { id: 64, code: "+694" },
  { id: 65, code: "+698" },
  { id: 66, code: "+850" },
  { id: 67, code: "+852" },
  { id: 68, code: "+853" },
  { id: 69, code: "+855" },
  { id: 70, code: "+886" },
  { id: 71, code: "+960" },
  { id: 72, code: "+965" },
  { id: 73, code: "+966" },
  { id: 74, code: "+967" },
  { id: 75, code: "+968" },
  { id: 76, code: "+970" },
  { id: 77, code: "+971" },
  { id: 78, code: "+974" },
  { id: 79, code: "+977" },
  { id: 80, code: "+975" },
  { id: 81, code: "+976" },
  { id: 82, code: "+992" },
  { id: 83, code: "+993" },
  { id: 84, code: "+994" },
  { id: 85, code: "+995" },
  { id: 86, code: "+996" },
  { id: 87, code: "+998" },*/
];
export default countryCodeList;
